import { render, staticRenderFns } from "./SocialStreamPosts.vue?vue&type=template&id=de29c076"
import script from "./SocialStreamPosts.vue?vue&type=script&lang=ts"
export * from "./SocialStreamPosts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports